// Path: src\Components\Popup\More\InviteCodePopup.jsx
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Popup from "../../Popup/BasePopup";
import Button from '../../CommonFields/Button';
import TextInput from '../../CommonFields/TextInput';
import { tournamentByCode } from "../../../api/tournament.api";
import { contestByCode } from "../../../api/contest.api";
import { scrimByCode } from "../../../api/scrim.api";
import { toastError } from "../../../Utilities/toast";

import TournamentViaCode from "../../Common/JoinViaTournamentCode";
import ContestViaCode from "../../Common/JoinViaContestCode";
import ScrimViaCode from "../../Common/JoinViaScrimCode";

const JoinViaInviteCodePopup = ({ isOpen, title, onClose }) => {
  const [inviteCode, setInviteCode] = useState("");
  const [error, setError] = useState("");
  const [helperText, setHelperText] = useState("");
  const [isTournament, setIsTournament] = useState(false);
  const [isContest, setIsContest] = useState(false);
  const [isPrivateContest, setIsPrivateContest] = useState(false);
  const [joinViaCodeTournament, setJoinViaCodeTournament] = useState({});
  const [joinViaCodeContest, setJoinViaCodeContest] = useState({});
  const [joinViaCodePrivateContest, setJoinViaCodePrivateContest] = useState({});

  const { t } = useTranslation();

  const handleInputChange = (e) => {
    let value = e.target.value.toUpperCase();
    value = value;
console.log(value)
    // Allow only alphanumeric characters
    const alphanumericRegex = /^[a-zA-Z0-9]*$/;

    // Ensure the value is alphanumeric and does not exceed 6 characters
    if (value.length <= 7 && alphanumericRegex.test(value)) {
      setInviteCode(value);
      setError("");
      setHelperText("");
    } else if (!alphanumericRegex.test(value)) {
      setError(true);
      setHelperText("invite code should contain only alphanumeric characters");
    }
  };

  const handleSubmit = () => {
    setJoinViaCodeTournament({});
    setJoinViaCodeContest({});
    setJoinViaCodePrivateContest({});
    setIsTournament(false)
    setIsContest(false)
    setIsPrivateContest(false)

    // Validation logic
    if (inviteCode === "") {
      setError(true);
      setHelperText("Please enter invite code");
    } else if (inviteCode.length < 6) {
      setError(true);
      setHelperText("Please enter a 6 character invite code");
    } else {
      // No error, proceed with the submission
      handleTournamentByCode(inviteCode)
      setError(false);
      setHelperText("");
      // Handle the invite code submission logic here
    }
  };

  async function handleTournamentByCode(code) {
    if (code?.trim()) {
      try {
        let payload = {
          user: JSON?.parse(localStorage?.getItem('profile'))?.user_id,
          code: code
        };
        let response = await tournamentByCode(payload);
        if (response?.success && response?.data) {
          localStorage.setItem("activeGame", response?.data?.gameAry?.name);
          localStorage.setItem("activeGameId", response?.data?.gameAry?._id);
          localStorage.setItem("activeGameTypeId", response?.data?.gameTypeAry?._id);
          setJoinViaCodeTournament(response?.data);
          setIsTournament(true)
          setIsContest(false)
          setIsPrivateContest(false)
          setInviteCode('');
        } else {
          handleContestByCode(code)
        }
      } catch (error) {
        handleContestByCode(code)
      }
    }
    else {
      toastError(t('errors.error_please_enter_invite_code'));
      setJoinViaCodeTournament({});
      setJoinViaCodeContest({});
      setJoinViaCodePrivateContest({});
      setIsTournament(false)
      setIsContest(false)
      setIsPrivateContest(false)
    }
  }

  async function handleContestByCode(code) {
    if (code?.trim()) {
      try {
        let payload = {
          user: JSON?.parse(localStorage?.getItem('profile'))?.user_id,
          code: code
        };
        let response = await contestByCode(payload);
        if (response?.success && response?.data) {
          localStorage.setItem("activeGame", response?.data?.gameAry?.name);
          localStorage.setItem("activeGameId", response?.data?.gameAry?._id);
          localStorage.setItem("activeGameTypeId", response?.data?.gameTypeAry?._id);
          setJoinViaCodeContest(response?.data);
          setIsTournament(false)
          setIsContest(true)
          setIsPrivateContest(false)
          setInviteCode('');
        } else {
          handleScrimByCode(code)
        }
      } catch (error) {
        handleScrimByCode(code)
      }
    }
    else {
      toastError(t('errors.error_please_enter_invite_code'));
      setJoinViaCodeTournament({});
      setJoinViaCodeContest({});
      setJoinViaCodePrivateContest({});
      setIsTournament(false)
      setIsContest(false)
      setIsPrivateContest(false)
    }
  }

  async function handleScrimByCode(code) {
    if (code?.trim()) {
      try {
        let payload = {
          user: JSON?.parse(localStorage?.getItem('profile'))?.user_id,
          code: code
        };
        let response = await scrimByCode(payload);
        if (response?.success && response?.data) {
          localStorage.setItem("activeGame", response?.data?.gameAry[0]?.name);
          localStorage.setItem("activeGameId", response?.data?.gameAry[0]?._id);
          localStorage.setItem("activeGameTypeId", response?.data?.gameTypeAry[0]?._id);

          setJoinViaCodePrivateContest(response?.data);
          setIsTournament(false)
          setIsContest(false)
          setIsPrivateContest(true)
          setInviteCode('');
        } else {
          toastError(t('tournament_list.tournament_not_found'));
          setJoinViaCodeTournament({});
          setJoinViaCodeContest({});
          setJoinViaCodePrivateContest({});
          setIsTournament(false)
          setIsContest(false)
          setIsPrivateContest(false)
          setInviteCode('');
        }
      } catch (error) {
        toastError(t('tournament_list.tournament_not_found'));
        setJoinViaCodeTournament({});
        setJoinViaCodeContest({});
        setJoinViaCodePrivateContest({});
        setIsTournament(false)
        setIsContest(false)
        setIsPrivateContest(false)
        setInviteCode('');
      }
    }
    else {
      toastError(t('errors.error_please_enter_invite_code'));
      setJoinViaCodeTournament({});
      setJoinViaCodeContest({});
      setJoinViaCodePrivateContest({});
      setIsTournament(false)
      setIsContest(false)
      setIsPrivateContest(false)
    }
  }

  return (
    <>
      <Popup isOpen={isOpen} title={title} onClose={onClose}>
        <div className="text-input-container promo-code-popup mt-2 mb-1">
          <TextInput
            labelName={"invite code"}
            placeholder={"enter invite code"}
            value={inviteCode}
            onChange={handleInputChange}
            error={error}
             className="capitalize-input"
          />
          <div className={`helper-text ${!helperText && 'no-error'}`}>
            {helperText}
          </div>
        </div>
        <div className='mb-2'>
        <Button text="Submit" onClick={handleSubmit}/>
        </div>
      </Popup>

      {isTournament && <TournamentViaCode joinViaCodeTournament={joinViaCodeTournament} />}
      {isContest && <ContestViaCode joinViaCodeContest={joinViaCodeContest} />}
      {isPrivateContest && <ScrimViaCode joinViaCodePrivateContest={joinViaCodePrivateContest} />}
    </>
  );
};

export default JoinViaInviteCodePopup;
